// utils/cartCalculations.js - محاسبات سبد خرید (Functional)
import React from 'react';
import NumberFormat from 'react-number-format';

/**
 * مقادیر اولیه برای totals
 */
export const getInitialTotals = () => ({
  totalKaser: 0,
  totalMakePay: 0,
  totalPrice: 0,
  totalDiscount: 0,
  totalWeight: 0,
  totalGr: 0,
});

/**
 * محاسبه totals از cart_report
 * @param {Object} cart_report - گزارش سبد خرید از سرور
 * @returns {Object} - totals محاسبه شده
 */
export const calculateTotals = (cart_report) => {
  if (!cart_report || Object.keys(cart_report).length === 0) {
    return getInitialTotals();
  }

  return {
    totalKaser: parseFloat(cart_report.total_kaser || 0).toFixed(3),
    totalMakePay: parseFloat(cart_report.total_make_pay || 0).toFixed(2),
    totalPrice: parseFloat(cart_report.total_price || 0).toFixed(0),
    totalDiscount: parseFloat(cart_report.total_discount || 0).toFixed(0),
    totalWeight: parseFloat(cart_report.total_weight || 0).toFixed(3),
    totalGr: (parseFloat(cart_report.total_weight || 0) + parseFloat(cart_report.total_kaser || 0)).toFixed(3),
  };
};

/**
 * محاسبه قیمت کل برای محصولات localStorage
 * @param {Array} products - آرایه محصولات از localStorage
 * @returns {string} - قیمت کل فرمت شده
 */
export const calculateLocalStorageTotal = (products) => {
  if (!products || products.length === 0) return '0';

  const total = products.reduce((sum, product) => {
    return sum + parseFloat(product.price || 0);
  }, 0);

  return parseFloat(total / 10).toFixed(0);
};

/**
 * تولید آیتم‌های نمایشی برای سبد خرید
 * @param {Object} totals - مجموع محاسبات
 * @param {Object} user - اطلاعات کاربر
 * @param {Function} translate - تابع ترجمه
 * @returns {Array} - آرایه آیتم‌های قابل نمایش
 */
export const getCartItems = (totals, user, translate) => {
  const cart_items_team = [
    {
      name: 'total_weight',
      render: <NumberFormat value={totals.totalWeight} suffix={' ' + translate('weight-unit') + ' '} displayType={'text'} thousandSeparator={true} />,
    },
    {
      name: 'total_make_pay',
      render: <NumberFormat value={totals.totalMakePay} suffix={'تومان'} displayType={'text'} thousandSeparator={true} />,
    },
    {
      name: 'total_kaser',
      render: <NumberFormat value={totals.totalKaser} suffix={' ' + translate('weight-unit') + ' '} displayType={'text'} thousandSeparator={true} />,
    },
    {
      name: 'total_gr',
      render: <NumberFormat value={totals.totalGr} suffix={' ' + translate('weight-unit') + ' '} displayType={'text'} thousandSeparator={true} />,
    },
    {
      name: 'total_discount',
      render: <NumberFormat value={totals.totalDiscount} suffix={' ' + translate('weight-unit') + ' '} displayType={'text'} thousandSeparator={true} />,
    },
  ];

  const cart_customer = [
    {
      name: 'total_price',
      render: <NumberFormat value={totals.totalPrice} suffix={'تومان'} displayType={'text'} thousandSeparator={true} />,
    },
  ];

  return user['is_teammate'] ? cart_items_team : cart_customer;
};

/**
 * محاسبه تخفیف برای محصول خاص
 * @param {Object} product - محصول
 * @returns {number} - مقدار تخفیف
 */
export const calculateProductDiscount = (product) => {
  if (!product.discount || !product.formula) return 0;

  const discountPercent = parseInt(product.discount.percent || 0);
  const weight = parseFloat(product.products.accounting_weight || 0);
  const k = parseInt(product.formula.k || 0);

  const withDiscount = ((k - discountPercent) * weight) / 100;
  const withoutDiscount = (k * weight) / 100;

  return withoutDiscount - withDiscount;
};

/**
 * محاسبه محاسبات همکار برای محصول
 * @param {Object} product - محصول
 * @returns {Object} - محاسبات کامل
 */
export const calculateTeammateMetrics = (product) => {
  const weight = parseFloat(product.products.accounting_weight || 0);
  const formula = product.formula || {};

  return {
    weight: weight.toFixed(3),
    kasr: parseFloat((formula.k * weight) / 100).toFixed(4),
    ojrat: parseFloat((formula.o * weight) / 10).toFixed(2),
    stonePrice: formula.r / 10,
    discount: calculateProductDiscount(product),
  };
};

// Default export object برای سازگاری با کد قبلی
const CartCalculations = {
  getInitialTotals,
  calculateTotals,
  calculateLocalStorageTotal,
  getCartItems,
  calculateProductDiscount,
  calculateTeammateMetrics,
};

export default CartCalculations;
